/**
 * Size of the workspace image of a card, in CSS pixels. The image is drawn
 * for exactly this size, so a card shown at another size gets its own value
 * here instead of being scaled by a style.
 */
export const workspaceCardAvatarSize = (dense: boolean | undefined): number =>
  dense ? 30 : 32;
